export const MAIN_SET_MESSAGE = 'MAIN//SET_MESSAGE';
export const MAIN_SET_FETCHING = 'MAIN//SET_FETCHING';
export const MAIN_SET_SIDEBAR_LOGO_URL = 'MAIN//SET_SIDEBAR_LOGO_URL';
export const MAIN_SET_IS_GLOBAL_MANAGEMENT_SYSTEM = 'MAIN//SET_IS_GLOBAL_MANAGEMENT_SYSTEM';
export const MAIN_SET_HAS_CL_ONLY_FEATURES = 'MAIN//SET_HAS_CL_ONLY_FEATURES';
export const MAIN_SET_SYSTEM_LOCALE = 'MAIN//SET_SYSTEM_LOCALE';
export const MAIN_SET_LATEST_SCROLL_TO_COMMENT = 'MAIN//SET_LATEST_SCROLL_TO_COMMENT';
export const MAIN_SET_PASSWORD_RESET_ENABLED = 'MAIN//SET_PASSWORD_RESET_ENABLED';

export const AUTH_SET_USER = 'AUTH//SET_USER';
export const AUTH_SET_TOKEN = 'AUTH//SET_TOKEN';
export const AUTH_SET_REFRESH_TOKEN = 'AUTH//SET_REFRESH_TOKEN';
export const AUTH_SET_TOKEN_EXPIRATION = 'AUTH//SET_TOKEN_EXPIRATION';
export const AUTH_SET_USER_ABILITIES = 'AUTH//SET_USER_ABILITIES';
export const AUTH_SET_PROJECT_ABILITIES = 'AUTH//SET_PROJECT_ABILITIES';
export const AUTH_SET_USER_SETTINGS = 'AUTH//SET_USER_SETTINGS';
export const AUTH_SET_USER_VERSION = 'AUTH//SET_USER_VERSION';



// WEBPACK FOOTER //
// ./src/store/types.js